import React, { Component, ReactNode } from 'react'
import Duo from '../lib/duo'

export type Callback = (...args: any[]) => void

export interface Props {
  sigRequest: string
  duoLogin: Callback
}

export class DuoIframeView extends Component<Props> {
  static displayName = 'DuoIframe'

  componentDidMount() {
    const { sigRequest, duoLogin } = this.props
    if (sigRequest) {
      Duo.init({
        submit_callback: (form) => {
          duoLogin(form.action, form.sig_response.value)
        },
      })
    }
  }

  render() {
    const { sigRequest } = this.props
    let iframe: ReactNode = null
    if (sigRequest) {
      iframe = (
        <iframe
          id="duo_iframe"
          width="620"
          height="330"
          frameBorder="0"
          data-host="api-eecc4173.duosecurity.com"
          data-sig-request={sigRequest}
          data-post-action={`${process.env.REACT_APP_BLINKER_API_URL}/oauth/login`}
        />
      )
    }

    return iframe
  }
}

export const DuoIframe = DuoIframeView
